import src from "IMAGE";
export default { src, width: 463, height: 87, blurWidth: 0, blurHeight: 0};
